module.exports = __webpack_public_path__ + "img/accfbd637698c473982f87be32a46f85.png";